import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './Home';
import ChatPage from './ChatPage';
import Bpm from './Bpm';
import BpmNew from './Bpm/New';
import BpmNewCase from './Bpm/New/NewCase';
import InstancePage from './InstancePage';
import InstanceDetails from './InstancePage/InstanceDetailsIndex';
import NewsDetailsIndex from './NewsPage/NewsDetailsIndex';
import NewsPage from './NewsPage';
import Answer from './Answer';
import Letter from './Letter';
import Draft from './Draft';
import Assign from './Assign';
import QuickAssign from './QuickAssign';
import Archive from './Archive';
import QuickArchive from './QuickArchive';
import CircularProgress from '../../components/CircularProgress';
import { IsEmpty } from '../../helper';
import { withOidcSecure } from '@axa-fr/react-oidc-context';
import queryString from 'query-string';
import DmsArchive from './Dms/DmsArchive';

function TeamWork(props: any) {
  const routeMatch = props.match;
  const [loading, setLoading] = useState(false);
  const qs = queryString.parse(props.location.search);

  useEffect(() => {
    if (!IsEmpty(qs)) {
      setLoading(true);
    }
  }, [qs.folder, qs.letterCode, qs.folderId, qs.referTypeId, qs.searchText]);

  useEffect(() => {
    if (loading) setLoading(false);
  }, [loading]);

  if (loading) return <CircularProgress className="gx-loader-400" />;

  return (
    <div className="gx-main-content-wrapper">
      <Switch>
        <Route
          path={`${routeMatch.url}/bpm/new/new-case`}
          component={BpmNewCase}
        />
        <Route path={`${routeMatch.url}/bpm/new`} component={BpmNew} />

        <Route path={`${routeMatch.url}/bpm`} component={Bpm} />
        <Route
          path={`${routeMatch.url}/home`}
          component={withOidcSecure(Home)}
        />

        <Route path={`${routeMatch.url}/chat`} component={ChatPage} />

        <Route path={`${routeMatch.url}/instance`} component={InstancePage} />

        <Route
          path={`${routeMatch.url}/instance-details`}
          component={InstanceDetails}
        />

        <Route
          path={`${routeMatch.url}/news/:announcementId`}
          component={withOidcSecure(NewsDetailsIndex)}
        />
        <Route
          path={`${routeMatch.url}/news`}
          component={withOidcSecure(NewsPage)}
        />
        <Route
          path={`${routeMatch.url}/answer/:replyToAll/:letterCode`}
          component={Answer}
        />
        <Route
          path={`${routeMatch.url}/letter/:folderCode/:letterCode`}
          component={Letter}
        />
        <Route
          path={`${routeMatch.url}/draft/:folderCode/:letterCode`}
          component={Draft}
        />
        <Route
          path={`${routeMatch.url}/assign/:letterCode`}
          component={Assign}
        />
        <Route
          path={`${routeMatch.url}/quick-assign/:letterCode`}
          component={QuickAssign}
        />
        <Route
          path={`${routeMatch.url}/archive/:folderCode/:letterCode`}
          component={Archive}
        />
        <Route
          path={`${routeMatch.url}/quick-archive/:folderCode/:letterCode`}
          component={QuickArchive}
        />
        <Route path={`${routeMatch.url}/dms`} component={DmsArchive} />
      </Switch>
    </div>
  );
}

export default TeamWork;
